import { Injectable } from '@angular/core';
import { Observable, from, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { get, post, del, put } from 'aws-amplify/api';


export interface ApiMessageResponse {
    isComplete: boolean;
    data: string[];
}

export interface AddImageRequest {
    key: string;
    fileName: string;
    content: string;
    tagId: number;
    isDefault: boolean;
}

export interface ApiImageResponse {
    id: number;
    key?: string;
    fileName: string;
    content: string;
    tagId: number;
    uploadDate: string;
    sizeInKb?: number;
}

export interface ImageAssetResponse {
    id: number;
    key: string;
    fileName: string;
    content: string;
    tagId: number;
    uploadDate: string;
    sizeInKb?: number;
    isDefault?: boolean;
}

export interface ImageTagResponse {
    id: number;
    name: string;
    tagKey: string;
    imageId: number;
}



@Injectable({
    providedIn: 'root'
})
export class ImageLibraryService {
  public fetchImages(): Observable<ImageAssetResponse[]> {
    const op = get({
      apiName: 'portal',
      path: 'house-events/images',
    });
    return from(op.response.then(async (r) => (await r.body.json()) as unknown as ImageAssetResponse[])).pipe(
      catchError((error) => throwError(() => error))
    );
  }
  uploadImage(payload: AddImageRequest): Observable<ApiMessageResponse> {
    const body = JSON.parse(JSON.stringify(payload)) as Record<string, any>;
    const op = post({
      apiName: 'portal',
      path: 'images',
      options: { body },
    });
    return from(op.response.then(async (r) => (await r.body.json()) as unknown as ApiMessageResponse)).pipe(
      catchError((error) => throwError(() => error))
    );
  }
  deleteImage(id: number): Observable<ApiMessageResponse> {
    const op = del({
      apiName: 'portal',
      path: `images?id=${id}`,
    });
    return from(op.response.then(async (r) => (await r.body.json()) as unknown as ApiMessageResponse)).pipe(
      catchError((error) => throwError(() => error))
    );
  }
  updateDefault(id: number): Observable<ApiMessageResponse> {
    const body = {
      isDefault: true,
    };
    const op = put({
      apiName: 'portal',
      path: `images?id=${id}`,
      options: { body },
    });
    return from(op.response.then(async (r) => (await r.body.json()) as unknown as ApiMessageResponse)).pipe(
      catchError((error) => throwError(() => error))
    );
  }
  public getHouseEventTags(): Observable<ImageTagResponse[]> {
    const op = get({
      apiName: 'portal',
      path: 'house-events/tags',
    });
    return from(op.response.then(async (r) => (await r.body.json()) as unknown as ImageTagResponse[])).pipe(
      catchError((error) => throwError(() => error))
    );
  }
}